// extracted by mini-css-extract-plugin
export default {"consentimiento-cookie":"ConsentimientoCookies_consentimiento-cookie__bc++f"};